import {required} from "vuelidate/lib/validators";  
const StrKontrolStandart = {
    data() {
      return { 
        StrKontrolStandartData:{
          SiraNo:"",
          AnaGrupId:"",
          StandartKodNo:"", 
          StandartGenelSarti:"",
          Deleted:false,
          Aktif:false,
        },
          FormDataType:{  
            SiraNo:{FieldName:"SiraNo",Field:"input",FieldTitle:this.$t('StrKontrolStandart.AddEdit.SiraNo')},
            AnaGrupId:{FieldName:"AnaGrupId",Field:"combobox",FieldTitle:this.$t('StrKontrolStandart.AddEdit.AnaGrupId'),ComboDataArray:[]}, 
            StandartKodNo:{FieldName:"StandartKodNo",Field:"input",FieldTitle:this.$t('StrKontrolStandart.AddEdit.StandartKodNo')},
            StandartGenelSarti:{FieldName:"StandartGenelSarti",Field:"input",FieldTitle:this.$t('StrKontrolStandart.AddEdit.StandartGenelSarti')}, 
          }   
      }
    },
    validations:{ 
      FormData: {
        SiraNo: { required }, 
          AnaGrupId: { required },  
          StandartKodNo: { required },  
          StandartGenelSarti: { required } 
      }
 
  },
  created(){  
    this.ActionsSabitGet(1562).then(res => {    
      for(var i=0; i<res.Data.length; i++)
        { 
          this.FormDataType.AnaGrupId.ComboDataArray.push({Id:res.Data[i].Id,Value:res.Data[i].Value})
        }    
    });  
  }
    
}
export default StrKontrolStandart